import { Box } from '@chakra-ui/react';
import DevIcon from 'devicon-react-svg';
import styled, { keyframes } from 'styled-components';
import { trioUITheme } from '@/styles/theme';

const transformAnimation = keyframes`
  0% { transform: scaleX(0); }
  100% { transform: scaleX(1); }
`;

export const HorizontalChartBar = styled(Box)`
  float: left;
  transform-origin: 0% 100%;
  animation: ${transformAnimation} 0.6s ease-in-out;
`;

export const TechStackIcon = styled(DevIcon)`
  width: 24px;
  height: 24px;
  fill: ${trioUITheme.colors['neutral-90']};
`;
